import React, {
  useState,
  useEffect,
  FunctionComponent,
  CSSProperties,
  useRef,
} from 'react';
import { Button, Col, FormControl, Modal, Row, Table } from 'react-bootstrap';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router-dom';
import apis from '../apis';
import { BulletinBoard } from '../apis/SOAP';
import { AuthedLayout, EditableTableDiv, EnchanceLink } from '../components';
import { ErrorDispatches } from '../redux/Dispatches';
import { ApplicationState } from '../redux/States';
import stHealthPNG from '../assets/images/home/StHealth.png';
import pwssPNG from '../assets/images/home/PWSS.png';
import sheetPNG from '../assets/images/home/Sheet.png';
import uploadPNG from '../assets/images/home/Cloud.png';
import uploadData from '../assets/images/home/Message.jpg';
import homeLogo from '../assets/images/home/logo03.png';
import { toast } from 'react-toastify';

const btnRow: CSSProperties = {
  display: 'flex',
};
const googleSheet: CSSProperties = {
  borderRadius: '21px',
  backgroundColor: 'rgb(204,233,255)',
  width: '180px',
  maxHeight: '161px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: '#a4a4a4 0px 1px 5px 1px',
  color: 'black',
  fontSize: '18px',
  margin: '10px 12px',
  paddingTop: '8px',
};
const uplodaToolsSheet: CSSProperties = {
  borderRadius: '21px',
  backgroundColor: 'rgb(255 204 204)',
  width: '180px',
  maxHeight: '161px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: '#a4a4a4 0px 1px 5px 1px',
  color: 'black',
  fontSize: '18px',
  margin: '10px 12px',
  paddingTop: '8px',
};
const uplodaApiSheet: CSSProperties = {
  border: 0,
  borderRadius: '21px',
  backgroundColor: '#fff',
  width: '180px',
  maxHeight: '161px',
  textAlign: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: '#a4a4a4 0px 1px 5px 1px',
  color: 'black',
  fontSize: '18px',
  margin: '10px 12px',
  paddingTop: '8px',
};
const mapState = (state: ApplicationState) => ({
  ...state.auth,
});
const mapDispatch = { ...ErrorDispatches };
const connector = connect(mapState, mapDispatch);

type Props = ConnectedProps<typeof connector>;

const homePage: FunctionComponent<Props> = ({
  user,
  loading,
  catchErrorForModal,
}) => {
  const [boardContents, setBoardContents] = useState<BulletinBoard[]>([]);
  const yearSem = user.semesters[user.currentSemester];
  const testRef = useRef<HTMLInputElement>(null);
  const [uploading, setUploading] = useState(false);
  const [uploadResult, setUploadResult] = useState(false);
  const [checkUploading, setCheckUploading] = useState(false);
  const [htmlResult, setHtmlResult] = useState('');
  const [modalContentText, setModalContentText] = useState<string>();
  const [uploadSuccess, setUploadSuccess] = useState<boolean>();
  const testSchoolId = [
    '1234561',
    '1234562',
    '1234563',
    '323456',
    '223456',
    '100301',
    '094681',
    '014507',
    '050404',
  ];
  if (loading) {
    useHistory().go(0);
    return <></>;
  }

  useEffect(() => {
    apis
      .getBulletinBoard(user.currentSchool)
      .then((datas) => {
        setBoardContents(datas);
      })
      .catch(catchErrorForModal);

    // if(testSchoolId.includes(user.currentSchool)) {
    apis
      .getSemesterHealthExamResult(yearSem.year, 1)
      .then((s) => {
        let html = s.startsWith('1') ? s.slice(1) : s; // 一第一個字元"1"
        html = html.replace(/font-size:(\d+)px/g, (_, size) => {
          return `font-size:${Math.round(parseInt(size) * 1.5)}px`; // 字體放大1.5倍
        });
        setHtmlResult(html);
        // setCheckUploading(true);
      })
      .catch(catchErrorForModal);
    // }

    apis.updateSchoolZip([user.currentSchool])
      .then((response) => {
        
      })
      .catch((err) => {
        console.log(err);
      })
  }, []);

  function uploadSemesterHealthExam() {
    apis
      .uploadSemesterHealthExam(yearSem.year, 1)
      .then((s) => {
        setCheckUploading(false);
        setUploadResult(true);
        setUploadSuccess(s.success);
        setModalContentText(s.success ? '稍後請確認資料檢核結果' : s.errors);
      })
      .catch(catchErrorForModal);
  }

  function onHide() {
    setUploading(false);
  }

  function onHideCheckUpload() {
    setCheckUploading(false);
  }

  function copyErrorsToClipboard(errors: string[]) {
    if (!Array.isArray(errors) || errors.length === 0) {
      alert('沒有可複製的錯誤訊息');
      return;
    }

    const text = errors.join('\n');

    navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('上傳失敗訊息已複製到剪貼簿');
      })
      .catch(() => {
        toast.error('複製失敗，請手動複製');
      });
  }

  return (
    <AuthedLayout>
      <Row className="mb-2 d-flex">
        {/* <Col xs={3} className='d-flex align-items-center'>
          <div>
            <img
              src={homeLogo}
              alt="icon"
              style={{ width: '280px', height: 'auto', marginBottom: '30px' }}
            />
          </div>
          <div>
            <div>{user.currentSchool}</div>
            <div>{user.schools[user.currentSchool].name || 'Unknows'}</div>
          </div>
        </Col> */}
        {/* <Col style={btnRow}> */}
        <Col sm={4} style={btnRow}>
          <EnchanceLink className="mr-2" to={'/student/phi'}>
            <img width={'200px'} alt="健康資料查詢" src={stHealthPNG} />
          </EnchanceLink>
          <a href="https://shis.k12ea.gov.tw/" target="_blank" rel="noreferrer">
            <img width={'200px'} alt="健康計畫網站" src={pwssPNG} />
          </a>
        </Col>
        <Col sm={4} className="text-center">
          <img
            src={homeLogo}
            alt="icon"
            style={{ width: '380px', height: 'auto', marginBottom: '30px' }}
          />
        </Col>
        <Col sm={4} style={{ display: 'flex', justifyContent: 'right' }}>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLScArFDHaGGXFDfsQPX4Grb7PrCLWW6XTfTRreiYIMe2Lio1hw/viewform"
            target="_blank"
            rel="noreferrer"
            style={googleSheet}
          >
            <img width={'100px'} alt="身分證修改" src={sheetPNG} />
            <span>學生身分證異動</span>
          </a>
          {/* <a
            href="https://drive.google.com/drive/u/2/folders/1mqHV6ElYNYjcqnjZxzNNdayuY_CTpGRk"
            target="_blank"
            rel="noreferrer"
            style={uplodaToolsSheet}
          >
            <img width={'100px'} alt="新舊系統資料移轉工具" src={uploadPNG} />
            <span>新舊系統資料移轉工具</span>
          </a> */}
          {
            // testSchoolId.includes(user.currentSchool) ? (
            // user.currentSchool == '100301' || user.currentSchool == '114744' ||  user.currentSchool == '200406' || user.currentSchool == '203507'? (
            <Button
              style={uplodaApiSheet}
              onClick={() => {
                apis
                  .getSemesterHealthExamResult(yearSem.year, 1)
                  .then((s) => {
                    let html = s.startsWith('1') ? s.slice(1) : s; // 一第一個字元"1"
                    html = html.replace(/font-size:(\d+)px/g, (_, size) => {
                      return `font-size:${Math.round(parseInt(size) * 1.5)}px`; // 字體放大1.5倍
                    });
                    setHtmlResult(html);
                    setCheckUploading(true);
                  })
                  .catch(catchErrorForModal);
              }}
            >
              <img width={'100px'} alt="上傳上學期學生資料" src={uploadData} />
              <span>資料上傳</span>
            </Button>
            // ) : (
            //   <></>
            // )
          }
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            className="d-flex justify-content-center"
            dangerouslySetInnerHTML={{ __html: htmlResult }}
          />
        </Col>
      </Row>
      <Row className="mb-2">
        <EditableTableDiv
          values={boardContents}
          headers={[
            { property: 'type', display: '分類', style: { width: '15%' } },
            {
              property: 'content',
              display: '標題',
              style: { width: '65%', textAlign: 'left' },
              onRender: (v, i, e, c) => (
                <a href={c.allValues.link} target="_blank" rel="noreferrer">
                  {v}
                </a>
              ),
            },
            {
              property: 'publishAt',
              display: '發佈時間',
              style: { width: '20%' },
            },
          ]}
        />
      </Row>
      {/* {testSchoolId.includes( user.currentSchool) ? (
        <Row>
          <Button onClick={uploadSemesterHealthExam}>上傳上學期資料</Button>
        </Row>
        ) : 
        ""
      } */}
      {/* <Modal
        show={uploading}
        aria-labelledby="upload-modal"
        backdrop="static"
        dialogClassName="modal-lg"
        centered
      >
        <Modal.Header closeButton onHide={onHide}>
          <Modal.Title id="student-editing-modal">資料上傳</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>是否上傳上學期學生健檢資料???</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={uploadSemesterHealthExam}>確認</Button>
        </Modal.Footer>
      </Modal> */}
      <Modal
        show={checkUploading}
        aria-labelledby="cehck-upload-modal"
        backdrop="static"
        dialogClassName="modal-xl"
        centered
      >
        <Modal.Header closeButton onHide={onHideCheckUpload}>
          <Modal.Title id="student-editing-modal">查看補上傳紀錄</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex justify-content-center"
            dangerouslySetInnerHTML={{ __html: htmlResult }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={uploadSemesterHealthExam}>上傳上學期資料</Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={uploadResult}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
      >
        <Modal.Header
          closeButton
          onHide={() => {
            setUploadResult(false);
          }}
        >
          <Modal.Title id="contained-modal-title-vcenter">
            {uploadSuccess ? '上傳成功' : '上傳失敗'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {Array.isArray(modalContentText) &&
              modalContentText.map((msg, idx) => (
                <li key={idx}>
                  {msg}
                  <br />
                </li>
              ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          {uploadSuccess ? (
            ''
          ) : (
            <>
              <Button
                onClick={() =>
                  copyErrorsToClipboard(modalContentText as unknown as string[])
                }
              >
                複製錯誤訊息
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </AuthedLayout>
  );
};

export const HomePage = connector(homePage);
function setModalContent(arg0: string) {
  throw new Error('Function not implemented.');
}
